import Vue from 'vue'

// Separate Vue instance acting as event bus
export const Events = new Vue()
